// extracted by mini-css-extract-plugin
export var noResults = "no-results-module--noResults--d81f2";